import React, { useEffect, useState } from 'react';
import Tip, { InterfaceTip } from './Tip';

import './tips.scss';
import APIService from '../../shared/api-service';

export default function Tips(props: any) {
  const [tips, setTips] = useState<Array<InterfaceTip>>();

  useEffect(() => {
    const apiService = new APIService();
    apiService.retrieveTips()
      .then((data) => {
        setTips(data?.tips);
    })
  }, [])
  
  return (
    <div>
      <div className="row">
        <div className="col-md-12 left">
        {tips?.map((tip: InterfaceTip, index: number) => (
          <Tip key={index} {...tip}></Tip>
         ))}
        </div>

      </div>
    </div>
  );
}

